import logoWithName from 'src/assets/logos/logo_with_name.svg'
import { StyledLink, StyledLogo } from './styled'

import * as ROUTES from 'src/constants/routes'

export const Logo = () => {
  return (
    <StyledLink to={ROUTES.HOME}>
      <StyledLogo src={logoWithName} alt="Logo" />
    </StyledLink>
  )
}
